/// <reference path="/js/viz/map/views/SelectedRegionTableView.js"/>
/// <reference path="/js/viz/util/Fips.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.map.views");

  /**
   * Displays the "NYC table" view on the right hand side of the map that
   * shows data for New York City for the current selections, if available
   */
  ns.NYCTableView = ns.SelectedRegionTableView.extend({
    el: "#nyc-table-container",
    name: "NYCTableView",

    getCurrentFips: function() {
      return ccc.viz.util.Fips.NYC;
    },

    render: function() {
      // Don't bother rerendering if the only thing that changed was the selected region
      if (
        _.size(this.model.changed) === 1 &&
        this.model.changed.hasOwnProperty("selectedFips")
      ) {
        return;
      }

      // Call the base implementation
      ns.NYCTableView.__super__.render.call(this);
    }
  });
})(jQuery, _);
